import React from 'react';

interface FormProgressBarProps {
  percent: number;
  pageLabel?: string;
}

/**
 * Sticky gamified progress bar for the public fill page. Pure presentational — the percent
 * computation lives in PublicFormFill (see the `percent` useMemo there), never here, so this
 * component has no opinion on pagination, repeating sections, or the progress floor.
 */
const FormProgressBar: React.FC<FormProgressBarProps> = ({ percent, pageLabel }) => {
  const clamped = Math.max(0, Math.min(100, percent));
  return (
    <div className="pff-progress">
      <div className="pff-progress-track">
        <div className="pff-progress-fill" style={{ width: `${clamped}%` }} />
      </div>
      <div className="pff-progress-label">
        <span>{clamped}% complete</span>
        {pageLabel && <span className="pff-page-indicator">{pageLabel}</span>}
      </div>
    </div>
  );
};

export default FormProgressBar;
